module.exports = __webpack_public_path__ + "static/media/Stochastic_Cellular_Tumor.12d92ded.png";